export const SAN_V1ResourcesDE: SAN_V1ResourcesBSInterface = {
  labelDone: "Datum der Aufgabenerledigung",
  errorMissingInput: "Bitte füllen Sie alle Felder aus",
  errors: {
    registerPic: "Das Bild, das Sie hochladen, ist zu groß.",
    recordAlreadyExists:
      "Diese Evidenz wurde bereits ausgefüllt. Sie können sie nicht erneut ausfüllen.",
  },
  input: {
    signatureTitle: "Unterschrift",
    datum: {
      label: "Datum",
      placeholder: "Bitte geben Sie das Datum ein",
      name: "datum",
    },
    dokument: {
      label: "Dokument",
      placeholder: "Bitte geben Sie das Dokument ein",
      name: "dokument",
      description: () => (
        <>
          <h4>Dateien hier ablegen oder zum Hochladen klicken.</h4>
          <span className="text-muted font-13">Nur Bilder, max 6MB</span>
        </>
      ),
    },
    vaziOd: {
      label: "Gültig ab",
      name: "vaziOd",
    },
    vaziDo: {
      label: "Gültig bis",
      name: "vaziDo",
    },
    uposlenik: {
      label: "Mitarbeiter",
      name: "uposlenik",
      placeholder: "Bitte geben Sie den Mitarbeiternamen ein",
    },
  },
  evidencijaForm: {
    buttonForward: "Unterschreiben",
    buttonBack: "Zurück",
  },
  successModal: {
    title: "Dateneingabe",
    body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "Durch die Auswahl der Option Unterschreiben bestätige ich, dass die Aufgabe gemäß den Anweisungen ausgeführt wurde!",
};

interface InputField {
  label: string;
  name: string;
  placeholder?: string;
  description?: () => JSX.Element;
}

interface Input {
  signatureTitle: string;
  datum: InputField;
  dokument: InputField;
  vaziOd: InputField;
  vaziDo: InputField;
  uposlenik: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface SAN_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errors: IErrors;
}
